"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FtolNewMask = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../javascript/Utilities");
require("../PropertyPage");
const ExternalInput_1 = require("./ExternalInput");
const Base_1 = require("../../../model/Base");
let ftolNewMaskMarkup = require("../../../templates/externalInputs/FtolNewMask.tmpl.html");
/**
* Modal new-mask for creating a document and set it as selected item a FTOL field
*/
class FtolNewMask extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        this.m_parentId = undefined;
        this.windowWidth = 1000;
        this.windowHeight = 750;
        this.needServerConfig = true;
        this.windowContentCssClass = "eiFtolNewMask";
        this.windowActions = ["Maximize", "Close"];
    }
    destroyWidgets() {
        this.widgetContainer.find(".propPage").synPropertyPage("destroy");
    }
    getUpdatedInstance() {
        const that = this;
        let curInst = that.currentInstance;
        return new Promise((resolve, reject) => {
            that.beginAjax();
            that.widgetContainer.find(".propPage").synPropertyPage("commitChanges", {
                validationFailed: (errMsg) => { reject(errMsg); },
                success: (inst, result) => {
                    let newEntryId = inst.items["cgdocument.docid"].valueToString();
                    that.serverAction({
                        action: "refreshft",
                        customData: { newentryid: newEntryId },
                        callBack: (data) => {
                            if (curInst.items[that.input.field.presentedField].multiValue) {
                                curInst.items[that.input.field.presentedField].valueAsStringArray.push(newEntryId);
                                curInst.items[that.input.field.fieldName].valueAsStringArray.push(data.additionalInformation["cefunc.233newentryname"]);
                            }
                            else {
                                curInst.items[that.input.field.presentedField].value = newEntryId;
                                curInst.items[that.input.field.fieldName].value = data.additionalInformation["cefunc.233newentryname"];
                            }
                            resolve(curInst);
                        },
                        fail: () => {
                            that.enableOkButton(false);
                        }
                    });
                },
                fail: () => { reject(); },
                cleanUp: () => { that.endAjax(); }
            });
        });
    }
    initPropertyPage() {
        const that = this;
        return new Promise((resolve, reject) => {
            that.widgetContainer.find(".propPage")
                .on("endInit", () => resolve())
                .on("instanceChanged", () => { that.updateOkButton(); })
                .on("valuesChanged valuesReverted", () => { that.updateOkButton(); })
                .synPropertyPage();
        });
    }
    updateOkButton() {
        const that = this;
        that.widgetContainer.find(".propPage").synPropertyPage("validate", {
            validationFailed: () => { that.enableOkButton(false); },
            validationSuccess: () => { that.enableOkButton(true); }
        });
    }
    updatePropertyPage(typeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            if (typeof that.m_parentId === "undefined") {
                const parentFieldName = that.serverConfig["parentfieldname"];
                if (parentFieldName && that.currentInstance.items[parentFieldName] && that.currentInstance.items[parentFieldName].value) {
                    if (parentFieldName === "cgdocument.docid")
                        that.m_parentId = that.currentInstance.id.valueAsString;
                    else {
                        const parentInstance = yield Utilities_1.synUtil.getInstanceAsync(that.currentInstance.items[parentFieldName].value.toString());
                        that.m_parentId = parentInstance.id.valueAsString;
                    }
                }
            }
            return new Promise((resolve, reject) => {
                that.widgetContainer.find(".propPage")
                    .one("endSetTemplate", () => resolve())
                    .synPropertyPage("setTemplate", {
                    mode: Base_1.PropertyPageMode.New,
                    typeId,
                    parentId: that.m_parentId
                });
            });
        });
    }
    initWindowContents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            that.enableOkButton(false);
            that.windowData.beginInit();
            try {
                let idData = { synUtil: Utilities_1.synUtil, allowedCategories: that.getAllowedCategories() };
                let template = kendo.template(ftolNewMaskMarkup);
                let result = template(idData);
                that.widgetContainer.html(result);
                yield that.initPropertyPage();
                let catChooserInitialized;
                if (idData.allowedCategories.length === 1) {
                    that.windowData.beginInit();
                    try {
                        yield that.updatePropertyPage(idData.allowedCategories[0]);
                    }
                    finally {
                        that.windowData.endInit();
                    }
                    catChooserInitialized = Promise.resolve();
                }
                else {
                    catChooserInitialized = new Promise((resolve, reject) => {
                        that.widgetContainer.find(".catChooser")
                            .on("categorySelected", (evt, cat) => {
                            that.windowData.beginInit();
                            that.updatePropertyPage(cat.id).then(() => {
                                that.windowData.endInit();
                            });
                        })
                            .on("initSuccess", (evt) => { resolve(); })
                            .synCategoryChooser({
                            useCategoryGroups: false,
                            showDependsCheckbox: false,
                            includeAbstractCategories: false,
                            catIds: idData.allowedCategories
                        });
                    });
                }
                yield catChooserInitialized;
            }
            catch (_a) {
            }
            finally {
                that.windowData.endInit();
            }
        });
    }
    getAllowedCategories() {
        const that = this;
        let cats = [];
        if (typeof that.serverConfig["allowedcategories"] !== "undefined") {
            let spl = that.serverConfig["allowedcategories"].split("|");
            for (let s of spl) {
                let i = parseInt(s, 10);
                if (!isNaN(i))
                    cats.push(i);
            }
        }
        return cats;
    }
}
exports.FtolNewMask = FtolNewMask;
